var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1H10V3.08014C9.69294 3.12818 9.5 3.18001 9.5 3.18001C6.63 3.86001 5 6.42002 5 9.50002V14L3 15V18H7.12613C7.56905 19.7202 9.12811 21 11 21C12.855 21 14.4257 19.7202 14.8726 18H19V15L17 14V9.50002C17 6.43002 15.36 3.86001 12.5 3.18001C12.5 3.18001 12.3071 3.12818 12 3.08014V1ZM11 4C10.6542 4 10.3358 4.03779 10.1024 4.07652C9.98691 4.09569 9.89524 4.11457 9.83503 4.12798C9.805 4.13466 9.78302 4.13994 9.77005 4.14314L9.75761 4.14626L9.74507 4.14964L9.73055 4.15307C7.41437 4.70186 6 6.76876 6 9.50002V14.6181L4 15.6181V17H7V17H15V17H18V15.618L16 14.6181V9.50002C16 6.77965 14.5762 4.70154 12.2687 4.15289L12.2546 4.14953L12.2433 4.14651L12.2299 4.14314C12.217 4.13994 12.195 4.13466 12.165 4.12798C12.1048 4.11457 12.0131 4.09569 11.8976 4.07652C11.6642 4.03779 11.3458 4 11 4ZM11 20C9.68866 20 8.58149 19.1627 8.17072 18H13.827C13.4121 19.1613 12.2977 20 11 20Z",
    fill: "#252122"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.54fcc529e3b9ba5e4057d073cb2cb436.svg";
export { ForwardRef as ReactComponent };